module.exports = __webpack_public_path__ + "static/media/ux.2b311bda.svg";